import { Heading } from "@/components/catalyst/heading";
import { InfoAlert } from "@/components/info-alert";
import { Logo } from "@/components/logo";
import { ReactNode } from "react";
import Form from "next/form";

type AuthFormProps = {
  title: string;
  errorMessage?: string | null;
  children: ReactNode;
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
};

export function AuthForm({
  title,
  errorMessage,
  children,
  onSubmit,
}: AuthFormProps) {
  return (
    <Form
      action="#"
      onSubmit={onSubmit}
      className="grid w-full max-w-sm grid-cols-1 gap-8"
    >
      <Logo />
      <Heading>{title}</Heading>
      {errorMessage && <InfoAlert variant="error" message={errorMessage} />}
      {children}
    </Form>
  );
}
